import { useRestaurantData } from './hooks/useRestaurantData'
import ClassicTemplate from './templates/ClassicTemplate'
import SmoothTemplate from './templates/SmoothTemplate'

function LoadingScreen() {
  return (
    <div style={{
      minHeight: '100vh', backgroundColor: '#000',
      display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '20px'
    }}>
      <div style={{
        width: '60px', height: '60px', borderRadius: '50%',
        border: '3px solid rgba(255,107,0,0.2)', borderTop: '3px solid #ff6b00',
        animation: 'spin 1s linear infinite'
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
      <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '14px', margin: 0 }}>Loading restaurant…</p>
    </div>
  )
}

function NotFound({ slug }) {
  return (
    <div style={{
      minHeight: '100vh', backgroundColor: '#000',
      display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '12px'
    }}>
      <p style={{ color: '#ff6b00', fontSize: '48px', margin: 0 }}>404</p>
      <p style={{ color: 'white', fontSize: '20px', margin: 0 }}>Restaurant not found</p>
      {slug && <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '14px', margin: 0 }}>"{slug}" doesn't exist</p>}
    </div>
  )
}

function App() {
  const { data, loading, error, slug } = useRestaurantData()

  if (loading) return <LoadingScreen />
  if (error || !data) return <NotFound slug={slug} />

  const restaurant = {
    name: data.org.name,
    logo: data.org.logo,
    description: data.org.description,
    contact: data.org.contact,
    socialMedia: data.org.socialMedia,
    heroTitle: data.org.heroTitle,
    heroSubtitle: data.org.heroSubtitle,
    primaryColor: data.org.primaryColor || '#ff6b00',
    templateId: data.org.templateId || 'classic',
    menu: data.menu,
  }

  if (restaurant.templateId === 'smooth') {
    return <SmoothTemplate restaurant={restaurant} />
  }
  return <ClassicTemplate restaurant={restaurant} />
}

export default App
